'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'hot-tub-person';
var width = 448;
var height = 512;
var aliases = ["hot-tub"];
var unicode = 'f593';
var svgPathData = 'M240 40c0 13.6 5.8 26.5 15.8 35.6l26.5 23.8c24 21.6 37.7 52.3 37.7 84.6 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-18.7-7.9-36.4-21.8-48.9l-26.5-23.8C203.5 93.1 192 67.2 192 40 192 26.7 202.7 16 216 16s24 10.7 24 24zM48 336l0 112c0 8.8 7.2 16 16 16l40 0 0-144-56 0 0 16zm117.4-64l-39.5-24.7c-7.6-4.8-16.4-7.3-25.4-7.3L64 240c-8.8 0-16 7.2-16 16l0 16 117.4 0zm75-9.7c10.2 6.4 21.9 9.7 33.9 9.7L384 272c35.3 0 64 28.7 64 64l0 112c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l36.5 0c18 0 35.6 5.1 50.9 14.6l89.1 55.7zM274.4 320l-26.4 0 0 144 48 0 0-144-21.6 0zm69.6 0l0 144 40 0c8.8 0 16-7.2 16-16l0-112c0-8.8-7.2-16-16-16l-40 0zm-144 0l-48 0 0 144 48 0 0-144zM328 16c13.3 0 24 10.7 24 24 0 13.6 5.8 26.5 15.8 35.6l26.5 23.8c24 21.6 37.7 52.3 37.7 84.6 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-18.7-7.9-36.4-21.8-48.9l-26.5-23.8C315.5 93.1 304 67.2 304 40 304 26.7 314.7 16 328 16zM64 40a56 56 0 1 1 0 112 56 56 0 1 1 0-112z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHotTubPerson = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;